import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, CardContent } from "@mui/material";
import { SubmitHandler, useForm, FormProvider } from "react-hook-form";
import { TNoticeDetail } from "src/types/notice";
import { PageContainer, Breadcrumb, BasicQuillForm } from "../common";
import Loading from "../common/Loading";
import { useLocation, useNavigate } from "react-router";
import { client } from "src/common/axiosClient";
import { timeArray } from "src/common/timeArray";

const defaultValues = {
  title: "",
  important: false,
  content: "",
};
function MaunalTheraistSchedule() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [isMetaData, setIsMetaData] = useState<boolean>(false);
  const [metaId, setMetaId] = useState<number>(0);
  const [doctorData, setDoctorData] = useState<any>({});
  const [metaData, setMetaData] = useState<any>({});

  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const [availablePatientCount, setAvailablePatientCount] = useState<number>(0);
  const [intervalMin, setIntervalMin] = useState<number>(30);

  const [launchStartAt, setLaunchStartAt] = useState<string>("13:00:00");
  const [launchEndAt, setLaunchEndAt] = useState<string>("14:00:00");

  const [monMorningStartAt, setMonMorningStartAt] =
    useState<string>("09:00:00");
  const [monMorningEndAt, setMonMorningEndAt] = useState<string>("13:00:00");
  const [monAfternoonStartAt, setMonAfternoonStartAt] =
    useState<string>("14:00:00");
  const [monAfternoonEndAt, setMonAfternoonEndAt] =
    useState<string>("18:00:00");
  const [monNightStartAt, setMonNightStartAt] = useState<string>("19:00:00");
  const [monNightEndAt, setMonNightEndAt] = useState<string>("23:00:00");
  const [monLunchStartAt, setMonLunchStartAt] = useState<string>("13:00:00");
  const [monLunchEndAt, setMonLunchEndAt] = useState<string>("14:00:00");

  const [tueMorningStartAt, setTueMorningStartAt] =
    useState<string>("09:00:00");
  const [tueMorningEndAt, setTueMorningEndAt] = useState<string>("13:00:00");
  const [tueAfternoonStartAt, setTueAfternoonStartAt] =
    useState<string>("14:00:00");
  const [tueAfternoonEndAt, setTueAfternoonEndAt] =
    useState<string>("18:00:00");
  const [tueNightStartAt, setTueNightStartAt] = useState<string>("19:00:00");
  const [tueNightEndAt, setTueNightEndAt] = useState<string>("23:00:00");
  const [tueLunchStartAt, setTueLunchStartAt] = useState<string>("13:00:00");
  const [tueLunchEndAt, setTueLunchEndAt] = useState<string>("14:00:00");

  const [wedMorningStartAt, setWedMorningStartAt] =
    useState<string>("09:00:00");
  const [wedMorningEndAt, setWedMorningEndAt] = useState<string>("13:00:00");
  const [wedAfternoonStartAt, setWedAfternoonStartAt] =
    useState<string>("14:00:00");
  const [wedAfternoonEndAt, setWedAfternoonEndAt] =
    useState<string>("18:00:00");
  const [wedNightStartAt, setWedNightStartAt] = useState<string>("19:00:00");
  const [wedNightEndAt, setWedNightEndAt] = useState<string>("23:00:00");
  const [wedLunchStartAt, setWedLunchStartAt] = useState<string>("13:00:00");
  const [wedLunchEndAt, setWedLunchEndAt] = useState<string>("14:00:00");

  const [thuMorningStartAt, setThuMorningStartAt] =
    useState<string>("09:00:00");
  const [thuMorningEndAt, setThuMorningEndAt] = useState<string>("13:00:00");
  const [thuAfternoonStartAt, setThuAfternoonStartAt] =
    useState<string>("14:00:00");
  const [thuAfternoonEndAt, setThuAfternoonEndAt] =
    useState<string>("18:00:00");
  const [thuNightStartAt, setThuNightStartAt] = useState<string>("19:00:00");
  const [thuNightEndAt, setThuNightEndAt] = useState<string>("23:00:00");
  const [thuLunchStartAt, setThuLunchStartAt] = useState<string>("13:00:00");
  const [thuLunchEndAt, setThuLunchEndAt] = useState<string>("14:00:00");

  const [friMorningStartAt, setFriMorningStartAt] =
    useState<string>("09:00:00");
  const [friMorningEndAt, setFriMorningEndAt] = useState<string>("13:00:00");
  const [friAfternoonStartAt, setFriAfternoonStartAt] =
    useState<string>("14:00:00");
  const [friAfternoonEndAt, setFriAfternoonEndAt] =
    useState<string>("18:00:00");
  const [friNightStartAt, setFriNightStartAt] = useState<string>("19:00:00");
  const [friNightEndAt, setFriNightEndAt] = useState<string>("23:00:00");
  const [friLunchStartAt, setFriLunchStartAt] = useState<string>("13:00:00");
  const [friLunchEndAt, setFriLunchEndAt] = useState<string>("14:00:00");

  const [satMorningStartAt, setSatMorningStartAt] =
    useState<string>("09:00:00");
  const [satMorningEndAt, setSatMorningEndAt] = useState<string>("13:00:00");
  const [satAfternoonStartAt, setSatAfternoonStartAt] =
    useState<string>("14:00:00");
  const [satAfternoonEndAt, setSatAfternoonEndAt] =
    useState<string>("18:00:00");
  const [satNightStartAt, setSatNightStartAt] = useState<string>("19:00:00");
  const [satNightEndAt, setSatNightEndAt] = useState<string>("23:00:00");
  const [satLunchStartAt, setSatLunchStartAt] = useState<string>("13:00:00");
  const [satLunchEndAt, setSatLunchEndAt] = useState<string>("14:00:00");

  const [sunMorningStartAt, setSunMorningStartAt] =
    useState<string>("09:00:00");
  const [sunMorningEndAt, setSunMorningEndAt] = useState<string>("13:00:00");
  const [sunAfternoonStartAt, setSunAfternoonStartAt] =
    useState<string>("14:00:00");
  const [sunAfternoonEndAt, setSunAfternoonEndAt] =
    useState<string>("18:00:00");
  const [sunNightStartAt, setSunNightStartAt] = useState<string>("19:00:00");
  const [sunNightEndAt, setSunNightEndAt] = useState<string>("23:00:00");
  const [sunLunchStartAt, setSunLunchStartAt] = useState<string>("13:00:00");
  const [sunLunchEndAt, setSunLunchEndAt] = useState<string>("14:00:00");

  // 체크박스 상태 관리
  const [dayOff, setDayOff] = useState<any>({
    Mon: { morning: false, afternoon: false, night: false },
    Tue: { morning: false, afternoon: false, night: false },
    Wed: { morning: false, afternoon: false, night: false },
    Thu: { morning: false, afternoon: false, night: false },
    Fri: { morning: false, afternoon: false, night: false },
    Sat: { morning: false, afternoon: false, night: false },
    Sun: { morning: false, afternoon: false, night: false },
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDoctorInfo();
  }, []);

  const getDoctorInfo = async () => {
    setDoctorData({});
    const response = await client.get(
      `admin/api/v1/medical-staff/MANUAL_THERAPIST/${id}`,
      {}
    );
    if (response.status === 200) {
      console.log(response);
      if (response.data.content) {
        setDoctorData(response.data.content);
        getDoctorMeta();
      }
    } else {
      console.log(response);
    }
  };

  const getDoctorMeta = async () => {
    try {
      const response = await client.get(
        `admin/api/v1/schedule-meta/MANUAL_THERAPIST/${id}`
      );
      if (response.status === 200) {
        console.log(response);
        if (response.data.content) {
          let data = response.data.content;
          setIsMetaData(true);
          setMetaId(data.id);
          setAvailablePatientCount(data.availablePatientCount);
          setIntervalMin(data.intervalMin);

          // 월요일
          setMonMorningStartAt(data.monday?.morning?.startAt || "");
          setMonMorningEndAt(data.monday?.morning?.endAt || "");
          setMonAfternoonStartAt(data.monday?.afternoon?.startAt || "");
          setMonAfternoonEndAt(data.monday?.afternoon?.endAt || "");
          setMonNightStartAt(data.monday?.night?.startAt || "");
          setMonNightEndAt(data.monday?.night?.endAt || "");
          setMonLunchStartAt(data.monday.lunch?.startAt || "");
          setMonLunchEndAt(data.monday.lunch?.endAt || "");

          // 화요일
          setTueMorningStartAt(data.tuesday?.morning?.startAt || "");
          setTueMorningEndAt(data.tuesday?.morning?.endAt || "");
          setTueAfternoonStartAt(data.tuesday?.afternoon?.startAt || "");
          setTueAfternoonEndAt(data.tuesday?.afternoon?.endAt || "");
          setTueNightStartAt(data.tuesday?.night?.startAt || "");
          setTueNightEndAt(data.tuesday?.night?.endAt || "");
          setTueLunchStartAt(data.tuesday.lunch?.startAt || "");
          setTueLunchEndAt(data.tuesday.lunch?.endAt || "");

          // 수요일
          setWedMorningStartAt(data.wednesday?.morning?.startAt || "");
          setWedMorningEndAt(data.wednesday?.morning?.endAt || "");
          setWedAfternoonStartAt(data.wednesday?.afternoon?.startAt || "");
          setWedAfternoonEndAt(data.wednesday?.afternoon?.endAt || "");
          setWedNightStartAt(data.wednesday?.night?.startAt || "");
          setWedNightEndAt(data.wednesday?.night?.endAt || "");
          setWedLunchStartAt(data.wednesday.lunch?.startAt || "");
          setWedLunchEndAt(data.wednesday.lunch?.endAt || "");

          // 목요일
          setThuMorningStartAt(data.thursday?.morning?.startAt || "");
          setThuMorningEndAt(data.thursday?.morning?.endAt || "");
          setThuAfternoonStartAt(data.thursday?.afternoon?.startAt || "");
          setThuAfternoonEndAt(data.thursday?.afternoon?.endAt || "");
          setThuNightStartAt(data.thursday?.night?.startAt || "");
          setThuNightEndAt(data.thursday?.night?.endAt || "");
          setThuLunchStartAt(data.thursday.lunch?.startAt || "");
          setThuLunchEndAt(data.thursday.lunch?.endAt || "");

          // 금요일
          setFriMorningStartAt(data.friday?.morning?.startAt || "");
          setFriMorningEndAt(data.friday?.morning?.endAt || "");
          setFriAfternoonStartAt(data.friday?.afternoon?.startAt || "");
          setFriAfternoonEndAt(data.friday?.afternoon?.endAt || "");
          setFriNightStartAt(data.friday?.night?.startAt || "");
          setFriNightEndAt(data.friday?.night?.endAt || "");
          setFriLunchStartAt(data.friday.lunch?.startAt || "");
          setFriLunchEndAt(data.friday.lunch?.endAt || "");

          // 토요일
          setSatMorningStartAt(data.saturday?.morning?.startAt || "");
          setSatMorningEndAt(data.saturday?.morning?.endAt || "");
          setSatAfternoonStartAt(data.saturday?.afternoon?.startAt || "");
          setSatAfternoonEndAt(data.saturday?.afternoon?.endAt || "");
          setSatNightStartAt(data.saturday?.night?.startAt || "");
          setSatNightEndAt(data.saturday?.night?.endAt || "");
          setSatLunchStartAt(data.saturday.lunch?.startAt || "");
          setSatLunchEndAt(data.saturday.lunch?.endAt || "");

          // 일요일
          setSunMorningStartAt(data.sunday?.morning?.startAt || "");
          setSunMorningEndAt(data.sunday?.morning?.endAt || "");
          setSunAfternoonStartAt(data.sunday?.afternoon?.startAt || "");
          setSunAfternoonEndAt(data.sunday?.afternoon?.endAt || "");
          setSunNightStartAt(data.sunday?.night?.startAt || "");
          setSunNightEndAt(data.sunday?.night?.endAt || "");
          setSunLunchStartAt(data.sunday.lunch?.startAt || "");
          setSunLunchEndAt(data.sunday.lunch?.endAt || "");

          // 휴진 초기 체크
          setDayOff((prev: any) => ({
            ...prev,
            Mon: {
              morning: !data.monday?.morning?.startAt,
              afternoon: !data.monday?.afternoon?.startAt,
              night: !data.monday?.night?.startAt,
            },
            Tue: {
              morning: !data.tuesday?.morning?.startAt,
              afternoon: !data.tuesday?.afternoon?.startAt,
              night: !data.tuesday?.night?.startAt,
            },
            Wed: {
              morning: !data.wednesday?.morning?.startAt,
              afternoon: !data.wednesday?.afternoon?.startAt,
              night: !data.wednesday?.night?.startAt,
            },
            Thu: {
              morning: !data.thursday?.morning?.startAt,
              afternoon: !data.thursday?.afternoon?.startAt,
              night: !data.thursday?.night?.startAt,
            },
            Fri: {
              morning: !data.friday?.morning?.startAt,
              afternoon: !data.friday?.afternoon?.startAt,
              night: !data.friday?.night?.startAt,
            },
            Sat: {
              morning: !data.saturday?.morning?.startAt,
              afternoon: !data.saturday?.afternoon?.startAt,
              night: !data.saturday?.night?.startAt,
            },
            Sun: {
              morning: !data.sunday?.morning?.startAt,
              afternoon: !data.sunday?.afternoon?.startAt,
              night: !data.sunday?.night?.startAt,
            },
          }));
        } else {
          setIsMetaData(false);
        }
      } else {
        console.error(
          "Failed to fetch doctor meta data with status: ",
          response.status
        );
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching doctor meta data: ",
        error
      );
    }
  };

  const saveClick = () => {
    if (isMetaData) {
      metaUpdate();
    } else {
      metaCreate();
    }
  };

  const formatScheduleData = (startAt: string, endAt: string) => {
    return startAt && endAt ? { startAt, endAt } : null;
  };

  const metaUpdate = async () => {
    const data = {
      monday: {
        morning: formatScheduleData(monMorningStartAt, monMorningEndAt),
        lunch: formatScheduleData(monLunchStartAt, monLunchEndAt),
        afternoon: formatScheduleData(monAfternoonStartAt, monAfternoonEndAt),
        night: formatScheduleData(monNightStartAt, monNightEndAt),
      },
      tuesday: {
        morning: formatScheduleData(tueMorningStartAt, tueMorningEndAt),
        lunch: formatScheduleData(tueLunchStartAt, tueLunchEndAt),
        afternoon: formatScheduleData(tueAfternoonStartAt, tueAfternoonEndAt),
        night: formatScheduleData(tueNightStartAt, tueNightEndAt),
      },
      wednesday: {
        morning: formatScheduleData(wedMorningStartAt, wedMorningEndAt),
        lunch: formatScheduleData(wedLunchStartAt, wedLunchEndAt),
        afternoon: formatScheduleData(wedAfternoonStartAt, wedAfternoonEndAt),
        night: formatScheduleData(wedNightStartAt, wedNightEndAt),
      },
      thursday: {
        morning: formatScheduleData(thuMorningStartAt, thuMorningEndAt),
        lunch: formatScheduleData(thuLunchStartAt, thuLunchEndAt),
        afternoon: formatScheduleData(thuAfternoonStartAt, thuAfternoonEndAt),
        night: formatScheduleData(thuNightStartAt, thuNightEndAt),
      },
      friday: {
        morning: formatScheduleData(friMorningStartAt, friMorningEndAt),
        lunch: formatScheduleData(friLunchStartAt, friLunchEndAt),
        afternoon: formatScheduleData(friAfternoonStartAt, friAfternoonEndAt),
        night: formatScheduleData(friNightStartAt, friNightEndAt),
      },
      saturday: {
        morning: formatScheduleData(satMorningStartAt, satMorningEndAt),
        lunch: formatScheduleData(satLunchStartAt, satLunchEndAt),
        afternoon: formatScheduleData(satAfternoonStartAt, satAfternoonEndAt),
        night: formatScheduleData(satNightStartAt, satNightEndAt),
      },
      sunday: {
        morning: formatScheduleData(sunMorningStartAt, sunMorningEndAt),
        lunch: formatScheduleData(sunLunchStartAt, sunLunchEndAt),
        afternoon: formatScheduleData(sunAfternoonStartAt, sunAfternoonEndAt),
        night: formatScheduleData(sunNightStartAt, sunNightEndAt),
      },

      intervalMin: 30,
      availablePatientCount: availablePatientCount,
    };
    console.log("data", data);
    const response = await client.put(
      `admin/api/v1/schedule-meta/MANUAL_THERAPIST/${id}/${metaId}`,
      data
    );
    if (response.status === 200) {
      console.log(response);
      alert("수정이 완료되었습니다.");
    } else {
      console.log(response);
    }
  };

  const metaCreate = async () => {
    const data = {
      monday: {
        morning: formatScheduleData(monMorningStartAt, monMorningEndAt),
        lunch: formatScheduleData(monLunchStartAt, monLunchEndAt),
        afternoon: formatScheduleData(monAfternoonStartAt, monAfternoonEndAt),
        night: formatScheduleData(monNightStartAt, monNightEndAt),
      },
      tuesday: {
        morning: formatScheduleData(tueMorningStartAt, tueMorningEndAt),
        lunch: formatScheduleData(tueLunchStartAt, tueLunchEndAt),
        afternoon: formatScheduleData(tueAfternoonStartAt, tueAfternoonEndAt),
        night: formatScheduleData(tueNightStartAt, tueNightEndAt),
      },
      wednesday: {
        morning: formatScheduleData(wedMorningStartAt, wedMorningEndAt),
        lunch: formatScheduleData(wedLunchStartAt, wedLunchEndAt),
        afternoon: formatScheduleData(wedAfternoonStartAt, wedAfternoonEndAt),
        night: formatScheduleData(wedNightStartAt, wedNightEndAt),
      },
      thursday: {
        morning: formatScheduleData(thuMorningStartAt, thuMorningEndAt),
        lunch: formatScheduleData(thuLunchStartAt, thuLunchEndAt),
        afternoon: formatScheduleData(thuAfternoonStartAt, thuAfternoonEndAt),
        night: formatScheduleData(thuNightStartAt, thuNightEndAt),
      },
      friday: {
        morning: formatScheduleData(friMorningStartAt, friMorningEndAt),
        lunch: formatScheduleData(friLunchStartAt, friLunchEndAt),
        afternoon: formatScheduleData(friAfternoonStartAt, friAfternoonEndAt),
        night: formatScheduleData(friNightStartAt, friNightEndAt),
      },
      saturday: {
        morning: formatScheduleData(satMorningStartAt, satMorningEndAt),
        lunch: formatScheduleData(satLunchStartAt, satLunchEndAt),
        afternoon: formatScheduleData(satAfternoonStartAt, satAfternoonEndAt),
        night: formatScheduleData(satNightStartAt, satNightEndAt),
      },
      sunday: {
        morning: formatScheduleData(sunMorningStartAt, sunMorningEndAt),
        lunch: formatScheduleData(sunLunchStartAt, sunLunchEndAt),
        afternoon: formatScheduleData(sunAfternoonStartAt, sunAfternoonEndAt),
        night: formatScheduleData(sunNightStartAt, sunNightEndAt),
      },

      intervalMin: 30,
      availablePatientCount: availablePatientCount,
    };
    console.log("data", data);
    const response = await client.post(
      `admin/api/v1/schedule-meta/MANUAL_THERAPIST/${id}`,
      data
    );
    if (response.status === 201) {
      console.log(response);
      alert("등록이 완료되었습니다.");
    } else {
      console.log(response);
    }
  };

  const availablePatientCountOnChange = (e: any) => {
    setAvailablePatientCount(e.target.value);
  };
  const intervalMinOnChange = (e: any) => {
    setIntervalMin(e.target.value);
  };

  const getMorningStart = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monMorningStartAt,
      Tue: tueMorningStartAt,
      Wed: wedMorningStartAt,
      Thu: thuMorningStartAt,
      Fri: friMorningStartAt,
      Sat: satMorningStartAt,
      Sun: sunMorningStartAt,
    };

    return weekMap[week] || "07:00:00";
  };

  const setMorningStart = (week: string, value: string) => {
    switch (week) {
      case "Mon":
        return setMonMorningStartAt(value);
      case "Tue":
        return setTueMorningStartAt(value);
      case "Wed":
        return setWedMorningStartAt(value);
      case "Thu":
        return setThuMorningStartAt(value);
      case "Fri":
        return setFriMorningStartAt(value);
      case "Sat":
        return setSatMorningStartAt(value);
      case "Sun":
        return setSunMorningStartAt(value);
      default:
        return "07:00:00";
    }
  };

  const getMorningEnd = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monMorningEndAt,
      Tue: tueMorningEndAt,
      Wed: wedMorningEndAt,
      Thu: thuMorningEndAt,
      Fri: friMorningEndAt,
      Sat: satMorningEndAt,
      Sun: sunMorningEndAt,
    };

    return weekMap[week] || "13:00:00";
  };
  const setMorningEnd = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonMorningEndAt,
      Tue: setTueMorningEndAt,
      Wed: setWedMorningEndAt,
      Thu: setThuMorningEndAt,
      Fri: setFriMorningEndAt,
      Sat: setSatMorningEndAt,
      Sun: setSunMorningEndAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const getLunchStart = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monLunchStartAt,
      Tue: tueLunchStartAt,
      Wed: wedLunchStartAt,
      Thu: thuLunchStartAt,
      Fri: friLunchStartAt,
      Sat: satLunchStartAt,
      Sun: sunLunchStartAt,
    };

    return weekMap[week] || "13:00:00";
  };

  const setLunchStart = (week: string, value: string) => {
    switch (week) {
      case "Mon":
        return setMonLunchStartAt(value);
      case "Tue":
        return setTueLunchStartAt(value);
      case "Wed":
        return setWedLunchStartAt(value);
      case "Thu":
        return setThuLunchStartAt(value);
      case "Fri":
        return setFriLunchStartAt(value);
      case "Sat":
        return setSatLunchStartAt(value);
      case "Sun":
        return setSunLunchStartAt(value);
      default:
        return "13:00:00";
    }
  };

  const getLunchEnd = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monLunchEndAt,
      Tue: tueLunchEndAt,
      Wed: wedLunchEndAt,
      Thu: thuLunchEndAt,
      Fri: friLunchEndAt,
      Sat: satLunchEndAt,
      Sun: sunLunchEndAt,
    };

    return weekMap[week] || "13:00:00";
  };
  const setLunchEnd = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonLunchEndAt,
      Tue: setTueLunchEndAt,
      Wed: setWedLunchEndAt,
      Thu: setThuLunchEndAt,
      Fri: setFriLunchEndAt,
      Sat: setSatLunchEndAt,
      Sun: setSunLunchEndAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const getAfternoonStart = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monAfternoonStartAt,
      Tue: tueAfternoonStartAt,
      Wed: wedAfternoonStartAt,
      Thu: thuAfternoonStartAt,
      Fri: friAfternoonStartAt,
      Sat: satAfternoonStartAt,
      Sun: sunAfternoonStartAt,
    };

    return weekMap[week] || "14:00:00";
  };

  const setAfternoonStart = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonAfternoonStartAt,
      Tue: setTueAfternoonStartAt,
      Wed: setWedAfternoonStartAt,
      Thu: setThuAfternoonStartAt,
      Fri: setFriAfternoonStartAt,
      Sat: setSatAfternoonStartAt,
      Sun: setSunAfternoonStartAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const getAfternoonEnd = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monAfternoonEndAt,
      Tue: tueAfternoonEndAt,
      Wed: wedAfternoonEndAt,
      Thu: thuAfternoonEndAt,
      Fri: friAfternoonEndAt,
      Sat: satAfternoonEndAt,
      Sun: sunAfternoonEndAt,
    };

    return weekMap[week] || "18:00:00";
  };

  const setAfternoonEnd = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonAfternoonEndAt,
      Tue: setTueAfternoonEndAt,
      Wed: setWedAfternoonEndAt,
      Thu: setThuAfternoonEndAt,
      Fri: setFriAfternoonEndAt,
      Sat: setSatAfternoonEndAt,
      Sun: setSunAfternoonEndAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const getNightStart = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monNightStartAt,
      Tue: tueNightStartAt,
      Wed: wedNightStartAt,
      Thu: thuNightStartAt,
      Fri: friNightStartAt,
      Sat: satNightStartAt,
      Sun: sunNightStartAt,
    };

    return weekMap[week] || "19:00:00";
  };

  const setNightStart = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonNightStartAt,
      Tue: setTueNightStartAt,
      Wed: setWedNightStartAt,
      Thu: setThuNightStartAt,
      Fri: setFriNightStartAt,
      Sat: setSatNightStartAt,
      Sun: setSunNightStartAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const getNightEnd = (week: string) => {
    const weekMap: { [key: string]: string } = {
      Mon: monNightEndAt,
      Tue: tueNightEndAt,
      Wed: wedNightEndAt,
      Thu: thuNightEndAt,
      Fri: friNightEndAt,
      Sat: satNightEndAt,
      Sun: sunNightEndAt,
    };

    return weekMap[week] || "23:00:00";
  };

  const setNightEnd = (week: string, value: string) => {
    const weekMap: {
      [key: string]: React.Dispatch<React.SetStateAction<string>>;
    } = {
      Mon: setMonNightEndAt,
      Tue: setTueNightEndAt,
      Wed: setWedNightEndAt,
      Thu: setThuNightEndAt,
      Fri: setFriNightEndAt,
      Sat: setSatNightEndAt,
      Sun: setSunNightEndAt,
    };

    const setFunction = weekMap[week];
    if (setFunction) {
      setFunction(value);
    } else {
      console.error("Invalid week day");
    }
  };

  const handleCheckboxChange = (day: string, period: string) => {
    setDayOff((prev: any) => {
      const newState = {
        ...prev,
        [day]: {
          ...prev[day],
          [period]: !prev[day][period], // 체크박스 상태 토글
        },
      };

      if (newState[day][period]) {
        switch (period) {
          case "morning":
            setMorningStart(day, "");
            setMorningEnd(day, "");
            break;
          case "afternoon":
            setAfternoonStart(day, "");
            setAfternoonEnd(day, "");
            break;
          case "night":
            setNightStart(day, "");
            setNightEnd(day, "");
            break;
          default:
            break;
        }
      }

      if (!newState[day][period]) {
        switch (period) {
          case "morning":
            setMorningStart(day, "09:00:00");
            setMorningEnd(day, "13:00:00");
            break;
          case "afternoon":
            setAfternoonStart(day, "13:00:00");
            setAfternoonEnd(day, "18:00:00");
            break;
          case "night":
            setNightStart(day, "18:00:00");
            setNightEnd(day, "23:00:00");
            break;
          default:
            break;
        }
      }

      return newState;
    });
  };

  return (
    <PageContainer>
      <Loading isLoading={isLoading} />
      <form>
        <Breadcrumb
          action={
            <div>
              <Button
                size="medium"
                variant="outlined"
                sx={{ marginRight: "8px" }}
                onClick={() => navigate(-1)}
              >
                목록으로
              </Button>
              <Button
                variant="contained"
                size="medium"
                onClick={() => saveClick()}
              >
                저장
              </Button>
            </div>
          }
        >
          <div className="flex items-center">
            <div className="w-32 mr-5">
              <img src={doctorData.profileImageUrl} alt="Apple Watch" />
            </div>
            {doctorData?.name} 기본 스케줄 설정페이지
          </div>
        </Breadcrumb>
        <Card>
          <CardContent>
            <div className="grid gap-6 mb-6 md:grid-cols-2">
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                  진료 시간(30분 마다)
                </label>
                <div className="flex text-center">
                  <input
                    type="number"
                    className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                    value={30}
                    disabled
                  />
                  <span className="text-xl mt-2">분</span>
                </div>
              </div>
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                  환자 수
                </label>
                <div className="flex text-center">
                  <input
                    type="number"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={availablePatientCount}
                    onChange={(e) => availablePatientCountOnChange(e)}
                  />
                  <span className="text-xl mt-2">명</span>
                </div>
              </div>
            </div>
            <div>
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      구분
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      월요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      화요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      수요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      목요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-white">
                      금요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-blue-400">
                      토요일
                    </th>
                    <th className="border border-gray-300 bg-[#212d62] p-2 text-center text-red-600">
                      일요일
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={`border border-gray-300 p-2 text-center`}>
                      오전시간
                    </td>
                    {daysOfWeek.map((week, index) => (
                      <td
                        className={`border border-gray-300 p-2 text-center ${
                          dayOff[week]["morning"] ? "bg-red-200" : ""
                        }`}
                        key={index}
                      >
                        {!dayOff[week]["morning"] ? (
                          <>
                            <div className="flex justify-center">
                              <select
                                value={getMorningStart(week)}
                                onChange={(e) =>
                                  setMorningStart(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="flex justify-center">~</div>
                            <div className="flex justify-center">
                              <select
                                value={getMorningEnd(week)}
                                onChange={(e) =>
                                  setMorningEnd(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          <div className="text-red-500 font-bold py-4">
                            휴진
                          </div>
                        )}

                        <div className="flex items-center justify-center mt-2">
                          <div className="flex items-center h-5">
                            <input
                              type="checkbox"
                              checked={dayOff[week]["morning"]}
                              onChange={() =>
                                handleCheckboxChange(week, "morning")
                              }
                              className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                            />
                          </div>
                          <label className="items-center ms-2 text-sm font-medium text-gray-900 ">
                            휴진
                          </label>
                        </div>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td className={`border border-gray-300 p-2 text-center`}>
                      점심시간
                    </td>
                    {daysOfWeek.map((week, index) => (
                      <td
                        className={`border border-gray-300 p-2 text-center `}
                        key={index}
                      >
                        <div className="flex justify-center">
                          <select
                            value={getLunchStart(week)}
                            onChange={(e) =>
                              setLunchStart(week, e.target.value)
                            }
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                          >
                            {timeArray.map((time, idx) => (
                              <option key={idx} value={`${time}:00`}>
                                {time}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="flex justify-center">~</div>
                        <div className="flex justify-center">
                          <select
                            value={getLunchEnd(week)}
                            onChange={(e) => setLunchEnd(week, e.target.value)}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                          >
                            {timeArray.map((time, idx) => (
                              <option key={idx} value={`${time}:00`}>
                                {time}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td className={`border border-gray-300 p-2 text-center`}>
                      오후
                    </td>
                    {daysOfWeek.map((week) => (
                      <td
                        className={`border border-gray-300 p-2 text-center ${
                          dayOff[week]["afternoon"] ? "bg-red-200" : ""
                        }`}
                      >
                        {!dayOff[week]["afternoon"] ? (
                          <>
                            <div className="flex justify-center">
                              <select
                                value={getAfternoonStart(week)}
                                onChange={(e) =>
                                  setAfternoonStart(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="flex justify-center">~</div>
                            <div className="flex justify-center">
                              <select
                                value={getAfternoonEnd(week)}
                                onChange={(e) =>
                                  setAfternoonEnd(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          <div className="text-red-500 font-bold py-4">
                            휴진
                          </div>
                        )}
                        <div className="flex items-center justify-center mt-2">
                          <div className="flex items-center h-5">
                            <input
                              type="checkbox"
                              checked={dayOff[week]["afternoon"]}
                              onChange={() =>
                                handleCheckboxChange(week, "afternoon")
                              }
                              className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                            />
                          </div>
                          <label className="items-center ms-2 text-sm font-medium text-gray-900 ">
                            휴진
                          </label>
                        </div>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td className={`border border-gray-300 p-2 text-center`}>
                      야간
                    </td>
                    {daysOfWeek.map((week) => (
                      <td
                        className={`border border-gray-300 p-2 text-center ${
                          dayOff[week]["night"] ? "bg-red-200" : ""
                        }`}
                      >
                        {!dayOff[week]["night"] ? (
                          <>
                            <div className="flex justify-center">
                              <select
                                value={getNightStart(week)}
                                onChange={(e) =>
                                  setNightStart(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="flex justify-center">~</div>
                            <div className="flex justify-center">
                              <select
                                value={getNightEnd(week)}
                                onChange={(e) =>
                                  setNightEnd(week, e.target.value)
                                }
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1"
                              >
                                {timeArray.map((time, idx) => (
                                  <option key={idx} value={`${time}:00`}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          <div className="text-red-500 font-bold py-4">
                            휴진
                          </div>
                        )}
                        <div className="flex items-center justify-center mt-2">
                          <div className="flex items-center h-5">
                            <input
                              type="checkbox"
                              checked={dayOff[week]["night"]}
                              onChange={() =>
                                handleCheckboxChange(week, "night")
                              }
                              className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                            />
                          </div>
                          <label className="items-center ms-2 text-sm font-medium text-gray-900 ">
                            휴진
                          </label>
                        </div>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </form>
    </PageContainer>
  );
}

export default MaunalTheraistSchedule;
